import { createContext, useContext, useMemo, type ReactNode } from "react";

interface ProgramContext {
  size?: string;
  showHeaderFields?: boolean;
  engine: string;
}

const programContext = createContext({
  size: "lg",
  showHeaderFields: true,
  engine: "pricing",
});

export const useProgramContext = () => {
  const context = useContext(programContext);

  const pathname = window.location.pathname;
  const params = new URLSearchParams(window.location.search);

  const engineParam = params.get("engine");

  // Update engine based on params, unless within pricing dashboard
  if (engineParam && context.engine !== engineParam) {
    context.engine = engineParam;
  }

  if (pathname.includes("pricing") && context.engine !== "pricing") {
    context.engine = "pricing";
  }

  return context;
};

export const ProgramContextProvider = ({
  size = "lg",
  showHeaderFields = true,
  children,
  engine,
}: ProgramContext & { children?: ReactNode }) => {
  const value = useMemo(
    () => ({
      size,
      showHeaderFields,
      engine,
    }),
    [size, showHeaderFields, engine],
  );

  return <programContext.Provider value={value}>{children}</programContext.Provider>;
};
